// utils/auth.js
export function isTokenValid(token) {
  try {
    if (!token) return false;
    // token provavelmente é JWT (header.payload.signature)
    const parts = token.split('.');
    if (parts.length < 2) return false;
    const payload = parts[1];
    // base64url -> base64
    const base64 = payload.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));
    const obj = JSON.parse(jsonPayload);
    if (obj && obj.exp) {
      const now = Math.floor(Date.now() / 1000);
      return Number(obj.exp) > now;
    }
    // Se não houver exp, considerar válido (não ideal, mas presumir válido)
    return true;
  } catch (e) {
    return false;
  }
}

export function logoutAndRedirect() {
  try { localStorage.removeItem('token'); } catch (e) {}
  // redireciona para a tela de login raiz
  window.location.href = '/';
}
